// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"'styles/breakpoints.module.css'","TABLET_WIDTH":"768px","container":"styles_container__T2qAB","text":"styles_text__nt85M","image":"styles_image__S4o9f"};